import React from "react";
import Page, { PageProps } from "../Page";
import { Form } from "antd";
import DataGrid from "../../components/app/grid/DataGrid";
import { SystemParametersConstants } from "../../../common/Constants";
import { ISystemParameterPresenter } from "../../../presenter/systemparameter/SystemParameterPresenter";
import CreateSystemParameterForm, {
  CreateSystemParameterFormProps
} from "./CreateSystemParameterForm";
import UpdateSystemParameterForm, {
  UpdateSystemParameterFormProps
} from "./UpdateSystemParameterForm";
import TickBox from "../../components/app/grid/TickBox";
import Loader from "../../components/Loader";

export interface Props extends PageProps {}
export interface State extends ISystemParameterPresenter {}

export default class SystemParametersPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { translate, systemParameters, deleteSystemParameter } = this.state;
    const CreateForm = Form.create<CreateSystemParameterFormProps>({})(
      CreateSystemParameterForm
    );

    const UpdateForm = Form.create<UpdateSystemParameterFormProps>({})(
      UpdateSystemParameterForm
    );

    const columns = [
      {
        title: translate("system_parameters_page.path"),
        dataIndex: "path",
        key: "path"
      },
      {
        title: translate("system_parameters_page.description"),
        dataIndex: "description",
        key: "description"
      },

      {
        title: translate("system_parameters_page.parameterType"),
        dataIndex: "parameterType",
        key: "parameterType"
      },
      {
        title: translate("system_parameters_page.parameter"),
        render: (text, record) => {
          if (record.parameterType === SystemParametersConstants.VCHAR)
            return <p>{record.valueVchar}</p>;
          else if (record.parameterType === SystemParametersConstants.CLOB)
            return <p>{record.valueClob}</p>;
          else if (record.parameterType === SystemParametersConstants.NUMBER)
            return <p>{record.valueNumber}</p>;
          else if (record.parameterType === SystemParametersConstants.INTEGER)
            return <p>{record.valueInteger}</p>;
          else if (record.parameterType === SystemParametersConstants.BOOLEAN)
            return <TickBox value={record.valueBoolean} />;
          else if (record.parameterType === SystemParametersConstants.DATE)
            return <p>{record.valueDateTime}</p>;
        }
      }
    ];

    const dataGrid = (
      <DataGrid
        title={translate("grids.system-parameters")}
        translate={translate}
        columns={columns}
        dataSource={systemParameters ? systemParameters : []}
        allowCreate={true}
        allowDelete={true}
        allowUpdate={true}
        createForm={CreateForm}
        createModalTitle={translate(
          "system_parameters_form.insert_modal_title"
        )}
        onCreate={this.state.createSystemParameter}
        onDelete={e => deleteSystemParameter(e.id)}
        deleteModalTitle={translate(
          "system_parameters_form.delete_modal_title"
        )}
        deleteModalMessage={translate(
          "system_parameters_form.delete_modal_message"
        )}
        updateForm={UpdateForm}
        updateModalTitle={translate(
          "system_parameters_form.update_modal_title"
        )}
        onUpdate={this.state.updateSystemParameter}
        addButtonText={translate("system_parameters_page.add_button_text")}
        booleanColumnKeys={["valid"]}
      />
    );
    
    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          loading={this.state.loaders.systemParametersLoader}
          translate={translate}
        />
      </Page>
    );
  }
}
